import { GroupIcon } from '__generatedTypes__/globalTypes'
import { DownloadIcon, FlashIcon, StarIcon } from 'assets/icons/consts'

export const DEBOUNCE_DELAY = 400
export const TAKE_ALL_ITEMS_COUNT = 999
export const SEARCH_ITEMS_COUNT = 20
export const DEFAULT_ITEMS_PER_PAGE = 10
export const SORTABLE_LIST_ANIMATION = 200

export const GroupIconsAWS: Record<GroupIcon, string> = {
  [GroupIcon.Star]: StarIcon,
  [GroupIcon.Download]: DownloadIcon,
  [GroupIcon.Flash]: FlashIcon,
}

export const API_VERSION_HEADER = 'X-Api-Version'
export const UNAUTHENTICATED_CODE = 'UNAUTHENTICATED'
export const BROADCAST_CHANNEL = 'broadcast-channel'
export const REMEMBER_ME = 'remember-me'
export const DAT_BOOSTER_EMAIL = 'team@datbooster.com'

export enum PlatformSlug {
  DATBooster = 'dat',
  OATBooster = 'oat',
  DATCrusher = 'cdat',
  PATBooster = 'pat',
  INBDEBooster = 'inbde',
  CasperBooster = 'casper',
  Admissions = 'admissions',
  NBDHEBooster = 'nbdhe',
  NDEBCrusher = 'ndeb-virtual-osce',
  CARSBooster = 'cars',
  MCATBooster = 'mcat',
  GREBooster = 'gre',
  NBEOPartOne = 'nbeo-part-1',
  DLOSCE = 'dlosce',
}

export const INBDEBoosterBaseSubject = 'cc14b92e-9dde-4e9d-85a4-a439b7c251ff'
export const NBDHEBoosterBaseSubject = '907d9340-dc0f-4d13-8967-d6e058b93ee4'
export const PATBoosterBaseSubject = '8cdc6c19-973f-4697-8e99-637660448b84'
export const CasperBoosterBaseSubject = 'a426e557-0c5f-40cf-8660-99466ff7bb5e'
export const CARSBoosterBaseSubject = '6e561da8-f3e1-48e5-b6b6-acdbf51edc30'
export const NDEBBoosterBaseSubject = '40b9010d-792c-4edb-99c3-a40d0d678046'

export const CARSBoosterCategory = 'cc7a8f0c-6d86-4da3-beaf-7741506b6530'

export const HIDDEN_SUBJECT_SLUG = 'hidden'
export const HIDDEN_SUBJECT_TITLE = 'Hidden'
